module.exports = __webpack_public_path__ + "static/img/14areaB_6.8c8202e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_6.png
// module id = 1120
// module chunks = 1